import { all } from 'redux-saga/effects';
import positionSaga from './positionSaga';
import candidateSaga from './candidateSaga';
import questionSaga from './questionSaga';
import DashboardSaga from './dashboardSaga';
import ProfileSaga from './profileSaga';
export default function* rootSaga() {
    yield all([positionSaga(), candidateSaga(), questionSaga(), DashboardSaga(), ProfileSaga()]);
}
